const addQueryNavigation = (vm, variableName, type = 'boolean', suffix, forgetLg = true) => {
  let queryParam = vm.$t(variableName)
  if (suffix) {
    queryParam += '-' + suffix
  }

  if (type === 'boolean') {
    vm[variableName] = queryParam in vm.$route.query
  } else {
    if (queryParam in vm.$route.query) {
      vm[variableName] = type === 'number'? parseInt(vm.$route.query[queryParam], 10) : vm.$route.query[queryParam]
    } else {
      vm[variableName] = null
    }
  }

  vm.$watch('$route', (newVal, oldVal) => {
    if (queryParam in oldVal.query && !(queryParam in newVal.query)) {
      if (type === 'boolean') {
        vm[variableName] = false
      } else {
        vm[variableName] = null
      }
    }
    if (!(queryParam in oldVal.query) && queryParam in newVal.query) {
      if (type === 'boolean') {
        vm[variableName] = true
      } else {
        vm[variableName] = type === 'number'? parseInt(newVal.query[queryParam]) : newVal.query[queryParam]
      }
    }
  })

  vm.$watch(variableName, val => {
    if (type === 'boolean' && val) {
      vm.$router.push({
        ...vm.$route,
        query: {
          ...vm.$route.query,
          [queryParam]: null // Null adds the key, but without value. Looks nicer.
        }
      })
    } else if (type !== 'boolean' && val !== null) {
      vm.$router.push({
        ...vm.$route,
        query: {
          ...vm.$route.query,
          [queryParam]: val
        }
      })
    } else if (queryParam in vm.$route.query) {
      if (!vm.$tailwind.breakpoints.lg || forgetLg) {
        if (history.state.back) {
          vm.$router.go(-1)
        } else {
          const updatedQuery = { ...vm.$route.query }
          delete updatedQuery[queryParam]
          vm.$router.replace({
            ...vm.$route,
            query: updatedQuery
          })
        }
      } else {
        const updatedQuery = { ...vm.$route.query }
        delete updatedQuery[queryParam]
        vm.$router.push({
          ...vm.$route,
          query: updatedQuery
        })
      }
    }
  })
}

export {
  addQueryNavigation
}
